const readStoredBoolean = (key: string): boolean | null => {
  if (typeof window === 'undefined') return null;
  try {
    const saved = localStorage.getItem(key);
    return saved === null ? null : saved === 'true';
  } catch {
    return null;
  }
};

let prefetchEnabled = readStoredBoolean('debug-prefetch-enabled') ?? false;
let concurrentDownloadEnabled =
  readStoredBoolean('debug-concurrent-download-enabled') ?? true;
let blobBadgeEnabled = readStoredBoolean('debug-blob-badge-enabled') ?? false;
const storedUseVariantUrl = readStoredBoolean('debug-variant-url-enabled');
let useVariantUrl = storedUseVariantUrl ?? true;

const variantUrlSubscribers = new Set<() => void>();

if (typeof window !== 'undefined') {
  const globalOptions = window as unknown as Record<string, unknown>;
  if (storedUseVariantUrl === null && '__USE_VARIANT_URL' in globalOptions) {
    useVariantUrl = !!globalOptions.__USE_VARIANT_URL;
  }
  globalOptions.__USE_VARIANT_URL = useVariantUrl;
}

export const isPrefetchEnabled = () => prefetchEnabled;
export const setPrefetchEnabled = (enabled: boolean) => {
  prefetchEnabled = enabled;
};

export const isConcurrentDownloadEnabled = () => concurrentDownloadEnabled;
export const setConcurrentDownloadEnabled = (enabled: boolean) => {
  concurrentDownloadEnabled = enabled;
};

export const isBlobBadgeEnabled = () => blobBadgeEnabled;
export const setBlobBadgeEnabled = (enabled: boolean) => {
  blobBadgeEnabled = enabled;
};

export const isUseVariantUrlEnabled = () => useVariantUrl;
export const setUseVariantUrl = (enabled: boolean) => {
  useVariantUrl = enabled;
  if (typeof window !== 'undefined') {
    (window as unknown as Record<string, unknown>).__USE_VARIANT_URL = enabled;
  }
  variantUrlSubscribers.forEach((subscriber) => subscriber());
};

export const subscribeUseVariantUrl = (subscriber: () => void) => {
  variantUrlSubscribers.add(subscriber);
  return () => {
    variantUrlSubscribers.delete(subscriber);
  };
};
